var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#9CA3AF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_13389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 5.46967C11.1768 5.76256 11.1768 6.23744 11.4697 6.53033L16.1893 11.25H5.5C5.08579 11.25 4.75 11.5858 4.75 12C4.75 12.4142 5.08579 12.75 5.5 12.75H16.1893L11.4697 17.4697C11.1768 17.7626 11.1768 18.2374 11.4697 18.5303C11.7626 18.8232 12.2374 18.8232 12.5303 18.5303L18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L12.5303 5.46967C12.2374 5.17678 11.7626 5.17678 11.4697 5.46967Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_13389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrow);
export default __webpack_public_path__ + "static/media/calendar-arrow.3c87e421841ecd9d4032a5d6884c1a1c.svg";
export { ForwardRef as ReactComponent };